import { StatusTagColor } from "../../../../components/deprecated/StatusTag/StatusTag";
import { DataCreator } from "../../../../utils/dataCreator";
import { t } from "i18next";

import { FirebaseData } from "../../General/FirebaseData";

type BookingKeyDataState = "verifying" | "creating" | "active" | "revoking" | "revoked" | "error" | "pendingBookingVerification";

export default class BookingKeyData extends FirebaseData {
  phoneNumber: string = "";
  lockID: string = "";
  state: BookingKeyDataState = "creating";

  setup(data: { [key: string]: any }) {
    if (typeof data.phoneNumber === "string") {
      this.phoneNumber = data.phoneNumber;
    }
    if (typeof data.lockID === "string") {
      this.lockID = data.lockID;
    }
    if (typeof data.state === "string") {
      this.state = data.state as BookingKeyDataState;
    }
    super.setup(data);
  }

  saveKeyUpdate(data: { [key: string]: any }, completion: () => void) {
    if (this.parent?.parent) {
      super.saveUpdateWithCompletionHandler(
        {
          updatedBy: DataCreator.getUpdatedBy(),
          ...data,
        },
        () => {
          completion();
        }
      );
    } else {
      completion();
    }
  }

  willBecomeActive(): boolean {
    return (
      this.state === "active" ||
      this.state === "creating" ||
      this.state === "verifying" ||
      this.state === "revoking" ||
      this.state === "pendingBookingVerification"
    );
  }

  getKeyState(): string {
    if (this.state === "active") {
      return t("main.unlocState_active");
    } else if (this.state === "creating") {
      return t("main.unlocState_creating");
    } else if (this.state === "error") {
      return t("main.unlocState_error");
    } else if (this.state === "revoked") {
      return t("main.unlocState_revoked");
    } else if (this.state === "revoking") {
      return t("main.unlocState_revoking");
    } else if (this.state === "verifying") {
      return t("main.unlocState_verifying");
    } else if (this.state === "pendingBookingVerification") {
      return t("main.pendingBookingVerification");
    }
    return "error";
  }

  getKeyColor(): StatusTagColor {
    if (this.state === "active") return "green";
    else if (this.state === "creating" || this.state === "pendingBookingVerification") return "blue";
    return "red";
  }
}

